import React from 'react';
import { FadeIn } from './Shared';
import { CheckCircle2 } from 'lucide-react';
export const ProductBreakdown = () => {
  const tomos = [{
    icon: '📘',
    title: 'Tomo 1 — El Switch Biológico',
    desc: 'Entendés por primera vez cómo funciona el sueño de tu bebé por dentro. Melatonina, cortisol, ciclos y regresiones explicados en lenguaje real. Después de este tomo, dejás de improvisar y empezás a leer a tu bebé.',
    benefit: 'Saber exactamente por qué tu bebé se despierta y qué hacer al respecto.'
  }, {
    icon: '📗',
    title: 'Tomo 2 — El Santuario del Sueño',
    desc: 'El ambiente donde duerme tu bebé puede estar saboteando todo sin que lo sepas. Oscuridad nivel 10, ruido blanco correcto, temperatura ideal y el protocolo de armado paso a paso.',
    benefit: 'Un cuarto que predispone al sueño solo, sin depender de vos.'
  }, {
    icon: '📙',
    title: 'Tomo 3 — El Reloj Maestro',
    desc: 'El timing lo es todo. Acostarlo 20 minutos tarde puede arruinar toda la noche. Las Ventanas de Sueño Dinámicas por edad: la herramienta más poderosa del sistema.',
    benefit: 'Saber el momento exacto para acostar a tu bebé cada vez.'
  }, {
    icon: '📕',
    title: 'Tomo 4 — Autonomía Gradual',
    desc: 'Que aprenda a dormirse solo, sin llorarlo ni abandonarlo. El método respetuoso paso a paso para que tu bebé desarrolle autonomía real sin trauma.',
    benefit: 'Un bebé que se duerme solo en la cuna, sin necesitar tus brazos cada vez.'
  }, {
    icon: '📓',
    title: 'Tomo 5 — El Manual de Crisis',
    desc: 'Para las noches donde todo se derrumba: dentición, regresiones, viajes, enfermedades. Protocolos de emergencia que aplicás en minutos, sin entrar en pánico.',
    benefit: 'Saber exactamente qué hacer a las 3 AM cuando nada parece funcionar.'
  }];
  const includes = ['Protocolo listo para aplicar esa noche', 'Tabla de ventanas por edad', 'Señales de cansancio real', 'Checklist de validación', 'Bitácora de seguimiento', 'FAQ completo'];
  return <section className="pt-4 md:pt-6 pb-8 md:pb-12 px-4 bg-navy-800/30" data-id="element-256">
      <div className="max-w-5xl mx-auto" data-id="element-257">
        <FadeIn data-id="element-258">
          <div className="text-center mb-10" data-id="element-259">
            <div className="inline-block bg-yellow-400/10 text-yellow-400 px-4 py-1 rounded-full text-xs font-bold tracking-wider mb-3 border border-yellow-400/30 shadow-[0_0_15px_rgba(250,204,21,0.2)]" data-id="element-260">
              EL SISTEMA COMPLETO
            </div>
            <h2 className="text-2xl md:text-4xl font-serif font-bold text-white mb-2 drop-shadow-[0_2px_10px_rgba(255,255,255,0.1)]" data-id="element-261">
              🏆 LO QUE RECIBÍS EN EL MEGAPACK
            </h2>
            <p className="text-base text-yellow-100 font-medium" data-id="element-262">
              5 Tomos + 5 Bonos — 4 a 24 meses
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 items-center mb-16" data-id="element-263">
            <div className="space-y-4" data-id="element-264">
              {tomos.map((tomo, index) => <div key={index} className="bg-navy-800/80 p-5 rounded-xl border border-navy-600 hover:border-yellow-400/40 hover:bg-navy-800 transition-all pt-[20px] pb-[20px] mt-[10px] mb-[10px] shadow-lg hover:shadow-[0_0_20px_rgba(250,204,21,0.1)] group" data-id="element-265">
                  <div className="flex items-start" data-id="element-266">
                    <span className="text-3xl mr-4 group-hover:scale-110 transition-transform origin-center" data-id="element-267">
                      {tomo.icon}
                    </span>
                    <div data-id="element-268">
                      <h3 className="text-xl font-bold text-white mb-2 group-hover:text-yellow-400 transition-colors" data-id="element-269">
                        {tomo.title}
                      </h3>
                      <p className="text-gray-100 mb-3 text-sm md:text-base" data-id="element-270">
                        {tomo.desc}
                      </p>
                      <div className="bg-navy-900/50 p-3 rounded-lg border border-navy-700/50" data-id="element-271">
                        <span className="text-yellow-400 font-bold text-xs uppercase tracking-wider block mb-1" data-id="element-272">
                          Lo que lográs:
                        </span>
                        <p className="text-white text-sm font-medium" data-id="element-273">
                          {tomo.benefit}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>)}
            </div>
            <div className="relative" data-id="element-274">
              <div className="absolute inset-0 bg-yellow-400/10 blur-[60px] rounded-full" data-id="element-275"></div>
            </div>
          </div>

          <div className="bg-gradient-to-b from-navy-800 to-navy-900 border border-navy-600 rounded-2xl p-8 md:p-10 pt-[0px] pb-[0px] shadow-2xl relative overflow-hidden" data-id="element-276">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-3/4 h-1 bg-gradient-to-r from-transparent via-yellow-400/50 to-transparent" data-id="element-277" />
            <h3 className="text-xl md:text-2xl font-serif font-bold text-center text-white mt-[24px] mb-[24px]" data-id="element-278">
              Cada tomo incluye:
            </h3>
            <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-4 mb-[24px]" data-id="element-279">
              {includes.map((item, index) => <div key={index} className="flex items-center space-x-3 bg-navy-900/80 border border-navy-700 p-4 rounded-lg hover:border-green-400/30 transition-colors" data-id="element-280">
                  <CheckCircle2 className="w-5 h-5 text-green-400 flex-shrink-0 drop-shadow-[0_0_5px_rgba(74,222,128,0.5)]" data-id="element-281" />
                  <span className="text-white font-medium" data-id="element-282">{item}</span>
                </div>)}
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};